export enum WachterTeams {
    Rollout_Critical_Power = 264,
}